import Service from "../../service/index";


const Police = {
    namespaced: true,
    state: {
        police_station: [],
    },
    mutations: {
        GET_POLICE: (state, data) => {
            state.police_station = data;
        },

    },
    actions: {
        setPolice({commit}){
            return Service.Police.getPolice()
                .then(data=>{
                    commit("GET_POLICE",data);
                })
        },
    }
};
export default Police;
